import { useEffect, useRef } from 'react';

const CALENDLY_URL =
  'https://calendly.com/stephanie-wolf-info/30min?hide_gdpr_banner=1&primary_color=6f8c28';
const CALENDLY_SCRIPT = 'https://assets.calendly.com/assets/external/widget.js';

declare global {
  interface Window {
    Calendly?: {
      initInlineWidget: (options: { url: string; parentElement: HTMLElement }) => void;
    };
  }
}

export default function Booking() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const init = () => {
      if (window.Calendly && containerRef.current) {
        containerRef.current.innerHTML = '';
        window.Calendly.initInlineWidget({
          url: CALENDLY_URL,
          parentElement: containerRef.current,
        });
      }
    };

    const existing = document.querySelector(`script[src="${CALENDLY_SCRIPT}"]`);
    if (existing) {
      init();
      return;
    }

    const script = document.createElement('script');
    script.src = CALENDLY_SCRIPT;
    script.async = true;
    script.onload = init;
    document.body.appendChild(script);
  }, []);

  return (
    <section id="kontakt" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 text-accent-900 px-4 py-1.5 text-xs md:text-sm font-semibold">
            <i className="ri-calendar-check-line"></i>
            Termin buchen
          </span>
          <div className="mt-4">
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              Buchen Sie Ihr unverbindliches Erstgespräch
            </h2>
          </div>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto">
            Wählen Sie einfach einen passenden Termin aus – wir sprechen in Ruhe über Ihre
            Fragen und ich erstelle Ihnen gerne ein <strong className="text-foreground-900">individuelles
            Angebot</strong>.
          </p>
        </div>

        <div className="mt-10 rounded-lg border border-background-200 bg-background-50 p-3 md:p-5">
          <div
            ref={containerRef}
            className="calendly-inline-widget w-full min-w-[320px] h-[620px] md:h-[700px]"
            data-url={CALENDLY_URL}
          ></div>
        </div>

        <p className="mt-4 text-center text-xs md:text-sm text-foreground-400">
          <i className="ri-lock-line mr-1"></i>
          Ihre Angaben werden vertraulich behandelt.
        </p>
      </div>
    </section>
  );
}